export enum LayoutTarget {
  MOBILE = 'mobile'
}
